import React, { useState, useEffect } from 'react';
import vr from './Verifiers';
import VainillaDialog from '../components/sharecomponents/vanilladialog';

const SyncNominaUsersButton = (p) => {

    useEffect(() => {

    }, []);
    const containerStyle = p?.containerStyle ?? 'bw-250 mb-2 text-s contenedor';
    const buttonStyle = p?.buttonStyle ?? 'btn btn-light border border-info shadow text-s round-xxl text-bold w-100 contenedor';
    const textButton = p?.textButton ?? "Sincronizar Usuarios (semana)";
    const [loader, setloader] = useState(false);
    const [dialog, setdialog] = useState({ show: false });

    const sync = async () => {
        const semana = vr.getLS("semana_orden_siembra");
        const resp = await vr.getDataAPI('dev/sincronizar_empleados_nomina', { semana }, setloader, setdialog);
        if (resp.estatus) {
            vr.activeDialog(setdialog, resp.msj, "Sincronización exitosa", "success",);
        }
        console.log(`Respuesta de la API: `, resp);
    }
    return (
        <>
            <div className={containerStyle}>
                <button className={buttonStyle + (loader ? ' disabled scale-continue-025' : '')} onClick={sync}>
                    {loader ? 'Sincronizando' : textButton}
                    {loader && <div className=" ms-2 spinner-border text-warning" role="status" />}
                </button>
            </div>
            <VainillaDialog data={dialog} />
        </>

    )
}

export default SyncNominaUsersButton;